import { api } from '../client';
import type { UUID } from '@/types/domain';
import type { DashboardSummary } from '@/types/insight';

/*
 * The school dashboard. Every figure is computed by the module that owns it;
 * only sections the caller may see are returned.
 */
export const insightApi = {
  /** Omit (or pass null) `campusId` for the whole school. */
  summary: (campusId?: UUID | null) =>
    api.get<DashboardSummary>('/dashboard/summary', {
      params: { campusId: campusId ?? undefined },
    }),
};
